import { handleResponse } from 'api/utils';
import getFetchOptions from 'utils/getFetchOptions';

export const validateContextualID = async (host: string, contextualId: string): Promise<string> => {
  const options = await getFetchOptions();
  return await fetch(`${host}/internal/utility/contextual-to-hex/${contextualId}`, options).then(handleResponse);
};
